const triggerDownload = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

/**
 * Synchronously triggers a browser file download from an already-fetched Blob.
 * Use this when you already have the file data in memory.
 *
 * @param blob - The file data to download.
 * @param fileName - The name the browser will use for the saved file.
 */
export const downloadFile = (blob: Blob, fileName: string): void => {
  triggerDownload(blob, fileName)
}

/**
 * Fetches a Blob via `getData`, then triggers a browser file download.
 * Use this when the file data needs to be fetched (e.g. from an API mutation) at the
 * point of download. If `getData` resolves to `undefined` no download is triggered.
 *
 * @param getData - A function that resolves to the file Blob, or `undefined` if unavailable.
 * @param fileName - The name the browser will use for the saved file.
 */
export const downloadFileAsync = async (
  getData: () => Promise<Blob | undefined>,
  fileName: string
): Promise<void> => {
  const blob = await getData()
  if (blob) triggerDownload(blob, fileName)
}
